import { CatalogItem } from 'angular-api-gateway/v1/model/catalogItem';
import { CatalogItemsListingResponse } from 'angular-api-gateway/v1/model/catalogItemsListingResponse';

const isCatalogListingBody: (body: unknown) => body is CatalogItemsListingResponse = (
  body: unknown
): body is CatalogItemsListingResponse => {
  if (!body || typeof body !== 'object') {
    return false;
  }

  const candidate: CatalogItemsListingResponse = body as CatalogItemsListingResponse;

  return Array.isArray(candidate.items) && typeof candidate.total === 'number' && !!candidate.filters;
};

/**
 * Keep first image only — listing card LCP uses `images[0].preview` → ImageUrl.
 * Do not clear `videos` (hydrate would drop CatalogItemVideo → image/video flicker).
 * Do not collapse CDN fields on that image (small savings, extra mismatch risk).
 *
 * Dual SSOT (not shared with home widgets):
 * - count/viewport slim: `catalog-listing-page-size` + FirstPageFill
 * - this module: TransferState field trim for `/catalog/items` via interceptor
 * - home: `slim-guest-widgets` + application-owned TS write (interceptor skips widgets key)
 */
const slimCatalogItem: (item: CatalogItem) => CatalogItem = (item: CatalogItem): CatalogItem => ({
  ...item,
  images: item.images?.length ? [item.images[0]] : [],
});

/**
 * Soft TransferState trim for catalog items listing.
 * SSR HTML is rendered from the full HTTP body; only ng-state is slimmed.
 * Keep filters intact — CSR hydrates filter chrome from the same TransferState hit.
 */
export const softStripCatalogListingTransferState: (body: unknown) => unknown = (body: unknown): unknown => {
  if (!isCatalogListingBody(body)) {
    return body;
  }

  return {
    ...body,
    items: body.items.map(slimCatalogItem),
  };
};

export const isCatalogItemsListingUrl: (url: string | null | undefined) => boolean = (
  url: string | null | undefined
): boolean => {
  if (!url) {
    return false;
  }

  try {
    const pathname: string = new URL(url).pathname.replace(/\/$/, '');
    return pathname.endsWith('/catalog/items');
  } catch {
    return /\/catalog\/items\/?(\?|$)/.test(url);
  }
};
